import { render } from "./Cards.vue?vue&type=template&id=1bbc30b6"
import script from "./Cards.vue?vue&type=script&lang=js"
export * from "./Cards.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/shop/Cards.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1bbc30b6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1bbc30b6', __exports__)) {
    api.reload('1bbc30b6', __exports__)
  }
  
  module.hot.accept("./Cards.vue?vue&type=template&id=1bbc30b6", () => {
    api.rerender('1bbc30b6', render)
  })

}


export default __exports__